module.exports = __webpack_public_path__ + "img/next_24_1.9c246b87.svg";